const clauseData = [
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
    ],
    isCommon: "yes",
    title: `Buyer's Financing Condition`,
    notes: `This clause protects the Buyer by making the purchase conditional on 
    securing financing with acceptable terms by a set date. It also sets a 
    deadline, allows the Buyer to walk away if financing isn't secured, and 
    ensures the Seller cooperates by giving property access for loan-related steps.`,
    text: `This contract is subject to the Buyer securing new financing, not to exceed _____% of the Purchase Price from a lender of the Buyer’s choice and with terms satisfactory to the Buyer, before ________. m. on__________________________, 20_______ (Condition Day). The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
    ],
    isCommon: "yes",
    title: `Buyer's Property Inspection Condition`,
    notes: `This condition protects the Buyer by allowing them to cancel or 
    renegotiate the deal if a licensed inspection reveals issues they're not 
    satisfied with. It ensures the Buyer can assess the property's condition 
    before committing, and requires the Seller to provide access for the inspection.`,
    text: `This contract is subject to the Buyer's satisfaction with a property inspection, conducted by a licensed home inspector, before ________. m. on _____________________________, 20_______ (Condition Day). The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [`Condo`, `Country Residential`],
    isCommon: "yes",
    title: `Review of Condominium Documents`,
    notes: `This condition protects the Buyer by allowing them to review 
    important condominium documents (like bylaws, financials, or reserve fund info) 
    and cancel the deal if they're not satisfied. It ensures the Buyer is fully 
    informed before committing to the purchase.`,
    text: `This contract is subject to the Buyer’s satisfaction with a review of the Documents before ________. m. on ________________________________, 20_______ (Condition Day), on the terms in the Country Residential Purchase Contract Condominium Property Schedule, selected as attached in clause 9.1.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
    ],
    isCommon: "yes",
    title: `Sale of Buyer's Property Condition`,
    notes: `This condition protects the Buyer by making the purchase dependent on 
    selling their current property by a set date. It prevents the Buyer from 
    being financially overcommitted and gives them time to free up funds before 
    completing the new purchase.`,
    text: `This contract is subject to the sale of the Buyer’s property before ________. m. on ________________________________, 20_______ (Condition Day), on the terms in the Sale of Buyer’s Property Schedule, selected as attached in clause 9.1.`,
  },
  {
    type: "clause",
    category: [`Country Residential`],
    isCommon: "yes",
    title: `Water`,
    notes: `This condition protects the Buyer by allowing them to confirm that 
    the property's water supply is reliable, safe, and sufficient. It gives the 
    Buyer the right to inspect well and water reports before committing, and 
    requires the Seller to provide access for testing.`,
    text: `This contract is subject to the Buyer’s satisfaction with the source and flow rate of the water supply and a review of well and water reports prepared by an inspector of the Buyer’s choice, before ________. m. on _____________________________, 20_______(Condition Day). The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [`Country Residential`],
    isCommon: "yes",
    title: `Septic System`,
    notes: `This condition protects the Buyer by allowing them to ensure the 
    septic system is in good working order. If the inspection reveals problems, 
    the Buyer can attempt to renegotiate or cancel the contract. It also 
    requires the Seller to allow reasonable access for the inspection.`,
    text: `This contract is subject to the Buyer's satisfaction with a review of a septic system inspection, prepared by an inspector of the Buyer’s choice, before ________. m. on _____________________________, 20_______ (Condition Day). The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [`Country Residential`],
    isCommon: "yes",
    title: `Country Residential Purchase Contract Property Schedule`,
    notes: `This condition protects the Buyer by giving them time to review key 
    property details listed in the Country Residential Purchase Contract Property 
    Schedule—such as land use, access, services, and water info. It ensures the 
    Seller provides this information by a set date, so the Buyer can make an 
    informed decision before committing.`,
    text: `This contract is subject to the Buyer's satisfaction with the information in the Country Residential Purchase Contract Property Schedule, selected as attached in clause 9.1, before ________. m. on _____________________________, 20_______ (Condition Day). The Seller will cooperate by providing the completed schedule, including any indicated water and well reports, before ________. m. on _____________________________, 20_______.`,
  },
  {
    type: "clause",
    category: [`Country Residential`],
    isCommon: "yes",
    title: `Subdivision Plan`,
    notes: `This condition protects the Buyer by allowing them to review the 
    subdivision plan to ensure the property boundaries, access, and layout meet 
    their needs. It also requires the Seller to provide an accurate copy of the 
    plan so the Buyer can make an informed decision before proceeding.`,
    text: `This contract is subject to the Buyer's satisfaction with a review of a subdivision plan for the Property before ________. m. on _____________________________, 20_______ (Condition Day). The Seller will cooperate by providing a true copy of the subdivision plan.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
    ],
    isCommon: "yes",
    title: `Additional Buyer's Conditions`,
    notes: `Insert any additional Condtions that are necessary to protect your 
    clients best interests in this Section.`,
    text: `See below in the Common Conditions Section below for any commonly 
    used conditions.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
    ],
    isCommon: "yes",
    title: `Additional Seller's Conditions`,
    notes: `Insert any additional Condtions that are necessary to protect your 
    clients best interests in this Section.`,
    text: `See below in the Common Conditions Section below for any commonly 
    used conditions.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Buyer's Financing Condition`,
    notes: `This clause protects the Buyer by making the purchase conditional on 
    securing financing with acceptable terms by a set date. It also sets a 
    deadline, allows the Buyer to walk away if financing isn't secured, and 
    ensures the Seller cooperates by giving property access for loan-related steps.`,
    text: `This contract is subject to the Buyer securing new financing from a lender of the Buyer’s choice and with terms satisfactory to the Buyer, before ________. m. on__________________________, 20_______. The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Buyer's Property Inspection Condition`,
    notes: `This condition protects the Buyer by allowing them to cancel or 
    renegotiate the deal if a licensed inspection reveals issues they're not 
    satisfied with. It ensures the Buyer can assess the property's condition 
    before committing, and requires the Seller to provide access for the inspection.`,
    text: `This contract is subject to the Buyer’s satisfaction with an inspection of the improvements on the Property, conducted by alicensed inspector, before ________. m. on _____________________________, 20_______. The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Sale of Buyer's Property Condition`,
    notes: `This condition protects the Buyer by making the purchase dependent on 
    selling their current property by a set date. It prevents the Buyer from 
    being financially overcommitted and gives them time to free up funds before 
    completing the new purchase.`,
    text: `This contract is subject to the sale of the Buyer’s property before ________. m. on ________________________________, 20_______, on the terms in the attached Sale of Buyer’s Property Schedule.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Water Condition`,
    notes: `This condition protects the Buyer by allowing them to confirm that 
    the property's water supply is reliable, safe, and sufficient. It gives the 
    Buyer the right to inspect well and water reports before committing, and 
    requires the Seller to provide access for testing.`,
    text: `This contract is subject to the Buyer's satisfaction with the source and the flow rate of the water supply and a review of well and water reports prepared by an inspector of the Buyer’s choice, before ________.m. on _____________________________, 20_______. The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `On-site Sewage System Condition`,
    notes: `This condition protects the Buyer by allowing them to confirm that 
    the on-site sewage system is functioning properly and meets standards. It 
    gives the Buyer the option to try and renegotiate or cancel if issues are 
    found, and requires the Seller to allow access for inspection.`,
    text: `This contract is subject to the Buyer's satisfaction with a review of the on-site sewage system inspection, prepared by an inspector of the Buyer’s choice, before ________. m. on _____________________________, 20_______. The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Agricultural Purchase Contract Property Schedule`,
    notes: `This condition protects the Buyer by allowing them to review and be 
    satisfied with the information provided by the Seller in the Agricultural 
    Purchase Contract Property Schedule (e.g., land use, zoning, and other 
    property details). If the Buyer is not satisfied, they can potentially 
    cancel or renegotiate the contract before the specified deadline.`,
    text: `This contract is subject to the Buyer's satisfaction with the information provided by the Seller in the attached Agricultural Purchase Contract Property Schedule, before ________. m. on _____________________________, 20_______.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Subdivision Plan`,
    notes: `This condition protects the Buyer by allowing them to review the 
    subdivision plan to ensure the property meets their expectations, such as 
    boundaries, layout, and access. It requires the Seller to provide an 
    accurate copy of the plan, ensuring the Buyer can make an informed decision 
    before the set deadline.`,
    text: `This contract is subject to the Buyer's satisfaction with a review of a subdivision plan for the Property before ________. m. on _____________________________, 20_______. The Seller will cooperate by providing a true copy of the subdivision plan.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Due Diligence`,
    notes: `This clause ensures the Seller provides the Buyer with all relevant 
    property documents (e.g., leases, permits, reports) within a set timeframe. 
    The Buyer must review these documents and conduct inspections, with the 
    option to cancel the contract if they're unsatisfied. The Buyer must keep 
    the documents confidential and return them if the deal doesn't go through.`,
    text: `(i) Within _____ Business Days after the date that acceptance of this contract is communicated, the Seller will provide to the Buyer true copies of all agreements, documents, reports and other materials respecting the Property that are in the possession or control of the Seller (the "Disclosure Documents"), including but not limited to: copies of Permitted Encumbrances, copies of leases for the Accepted Tenancies, environmental reports, operating information, surveyors plans and reports, real property reports, permits, verification of GST payable, and <br/>
    (ii) The Buyer will keep all Disclosure Documents and information obtained from the Seller in strict confidence and will only make such information available to the Buyer’s employees, agents and professional advisors on a need to know basis. Should this transaction not be completed, the Buyer will return the Disclosure Documents including all copies to the Seller immediately. <br/>
    (iii) This contract is subject to the Buyer’s satisfaction with the results of its review of the Disclosure Documents and its inspections of the Property, before ________. m. on _____________________________, 20_______.
    `,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Additional Buyer's Conditions`,
    notes: `Insert any additional Condtions that are necessary to protect your 
    clients best interests in this Section.`,
    text: `See below in the Common Conditions Section below for any commonly 
    used conditions.`,
  },
  {
    type: "clause",
    category: [`Agricultural`],
    isCommon: "yes",
    title: `Additional Seller's Conditions`,
    notes: `Insert any additional Condtions that are necessary to protect your 
    clients best interests in this Section.`,
    text: `See below in the Common Conditions Section below for any commonly 
    used conditions.`,
  },

  /*COMMMONLY USED CONDITIONS*/
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Walkthrough (Prior to Completion Day)`,
    notes: `This walkthrough term is to be used when you want more flexibility 
    in the walkthrough date. Choose the statement that applies for the first 
    blank and then insert the appropriate number of times the Buyer can 
    visit the property.`,
    text: `The Buyer will have the right to a ________(walk-through, pre-closing viewing) of  the Property prior to Completion Day, to a maximum of ____ times. The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Walkthrough (Specified Date of Walkthrough)`,
    notes: `This walkthrough term is to be used when you want a specific 
    walkthrough date set for the Buyer. This provides less flexibility than 
    the term above, but is more specific as to when the walkthrough will 
    occur.`,
    text: `The Buyer will have the right to a ______(walk through, pre-closing viewing)of the  Property on _________________________, 20__ (specify date and time, if  required). The Seller will cooperate by providing access to the Property on reasonable terms.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Commission Differs from MLS or Off Market Listing`,
    notes: `This clause is used to clarify how 
    the Buyer's brokerage will be compensated, especially when a standard 
    cooperating commission (usually paid through the listing brokerage) is 
    not being paid or is insufficient.`,
    text: `The Sellers and the Buyers agree that upon closing the Seller’s lawyer will pay to the Buyer’s brokerage _________________% (plus GST), so that the Buyer may fulfill its obligations under the Buyer representation agreement, in lieu of the cooperating commission.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Realtor Disclosure - Realtor is the Buyer - may be resold for profit`,
    notes: `This clause is used to ensure full transparency and legal 
    protection when a licensed real estate agent in Yukon is personally 
    buying a property. It is a legal requirement to disclose these situations.`,
    text: `The Buyer discloses and the Seller acknowledges that this home is being purchased by a licensed agent in AB and will be used as a rental, residence, renovation or resold at any time in the future for a profit or loss.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Realtor Disclosure - Listing Agent is a REALTOR®`,
    notes: `This clause is used to ensure transparency and legal compliance 
    when the listing agent has interest in the property, either direct or 
    indirect. Complete the clause with the appropriate information by 
    inserting either "does" or "does not" with respect to whether there is 
    financial interest in the property.`,
    text: `The listing agent discloses and the Buyer(s) acknowledge that the listing agent is a licensed real estate agent with eXp Realty in the province of Yukon and does (or does not) have financial interest in the property.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Realtor Disclosure - Representing a Relative (Indirect Interest)`,
    notes: `This clause is used to ensure transparency and legal compliance 
    when the listing/Buyer's agent is representing a relative in the transaction. 
    Complete the clause with the appropriate information by 
    inserting either "Listing Agent" or "Buyer's Agent" with respect to who you 
    represent in the transaction.`,
    text: `Listing Agent (or Buyer's Agent) is related to Seller (or Buyer) and is a licensed agent in the Province of Yukon with eXp Realty.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Seller's Condition for Back Up Offer`,
    notes: `This condition makes the contract dependent on the Seller securing a 
    release from all obligations under a previous purchase agreement 
    (identified by its contract number). It ensures the Seller is no longer 
    bound by the earlier contract before the specified deadline, protecting the 
    Buyer from any potential conflicts or legal issues that may arise from the 
    prior agreement.`,
    text: `This contract is subject to the Seller obtaining a written release from all  obligations under a previously accepted Purchase Contract number ________,  before ______ ___m on ___________, 20___ (Condition Day).`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Term for Back Up Offer`,
    notes: `This clause allows the Buyer to withdraw their backup offer at any 
    time before the Seller removes their condition (e.g., securing financing or 
    approval). Once the Seller waives their condition, the Buyer cannot withdraw 
    or change the offer. Additionally, the Seller will not accept any extensions 
    to the current offer, setting a firm deadline for acceptance.`,
    text: `Buyers may withdraw their backup offer by serving written notice to the Sellers at any time up until Sellers deliver notice removing the Seller's condition to the Buyer. Once the Seller has waived the Seller's condition, the Buyer can no longer exercise this term.  No extensions to the current offer will be accepted by the Seller.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Permits required but were not obtained - Seller Disclosure`,
    notes: `This clause ensures that the Seller is legally obligated to disclose 
    any known lack of permits for development on the property. The Seller must 
    explicitly state if any development was completed without the necessary 
    permits, informing the Buyer of potential issues or legal risks associated 
    with the property.`,
    text: `The Purchase Contract requires the Seller to disclose known lack of permits for any  development on the Property. The following clause provides this disclosure: 
The Seller discloses that ________________________development on the Property  was completed without the required permits. 
`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Estate Sale (Term) - Completion Day Delayed`,
    notes: `In order for an estate to be sold, the Seller of the estate must 
    have certain information in place. Review the estate term & condition in 
    this section to see which one best applies to your transaction so that 
    the Seller has the time to obtain the required information.`,
    text: `The Buyer acknowledges that the Seller of the Property is an estate and a Grant has not yet been issued from the Courts. The Seller acknowledges that the  persons signing this contract have applied for a Grant and that anyone entitled to  a share of the Property has consented to this sale. The Buyer and Seller agree  that if a Grant has not been obtained by the Completion Day, then the Completion Day will be delayed until the Seller is able to provide a Grant and  a Transfer of Land.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Estate Sale (Condition) - Issuance of a Grant of Probate`,
    notes: `In order for an estate to be sold, the Seller of the estate must 
    have certain information in place. Review the estate term & condition in 
    this section to see which one best applies to your transaction so that 
    the Seller has the time to obtain the required information.`,
    text: `This contract is subject to the Seller receiving a grant of probate before ____ ____m. on  __________________, 2025 (Condition Day).`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Repairs Needed`,
    notes: `This clause requires the Seller to complete specific repairs at 
    their expense by a set date, using a qualified contractor. The Seller must 
    provide a receipt as proof of completion. The Buyer's lawyer will withhold a 
    specified amount from the purchase price until the receipt is provided. If 
    the repairs aren't done by the deadline, the funds are returned to the Buyer.`,
    text: `The Seller, at the Seller’s expense, will repair ________(detail what needs to be  done), before ____ __ .m. on _______(date).<br/><br/>  

The repairs will be done by __________(professional contractor of the Seller or  Buyer’s choice, a named contractor, etc.) with materials and quality of workmanship equal to or better than the surrounding construction and the Seller  will provide the Buyer with a copy of the receipt. The Seller and Buyer agree that  the receipt is evidence of completion of this term. <br/><br/>

The Buyer will instruct the Buyer’s lawyer to hold back $________ from the  payment of the Purchase Price until the receipt is provided.<br/><br/>

If the receipt is not provided by the agreed date, the hold back funds will be paid  to the Buyer.  
`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Professional Cleaning Needed`,
    notes: `This clause requires the Seller to have specific items 
    (e.g., carpets, windows, appliances) professionally cleaned at their expense 
    before a set deadline. The Buyer's lawyer will hold back a specified amount 
    from the purchase price until the Seller provides a receipt for the cleaning. 
    If the receipt isn't provided by the agreed date, the withheld funds will 
    be returned to the Buyer.`,
    text: `The Seller, at the Seller’s expense will have _____________(detail what needs to be  cleaned) professionally cleaned before ____ __ .m. on _______, 20____ . The Buyer will instruct the Buyer’s lawyer to hold back $________ from the  payment of the         Purchase Price until the receipt is provided.  If the receipt is not provided by the agreed date, the holdback funds will be paid  to the Buyer.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `HOA Fees Disclosure`,
    notes: `This clause states that, to the best of the Seller's knowledge, the 
    current monthly Homeowner Association (HOA) fee for the property is a 
    specified amount. However, the Buyer is responsible for verifying this fee, 
    ensuring the Buyer is aware of and confirms the exact amount before 
    finalizing the purchase.`,
    text: `To the best of the Seller's knowledge and to be verified by the Buyer, the total current  monthly contribution for the Property’s Home Owner Association (HOA) fee is:  $__________________.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Seller is a Non-Resident`,
    notes: `The Purchase Contract includes a Seller warranty that the Seller is 
    “not a non-resident  for the purposes of the Income Tax Act (Canada)” 
    (clause 6.1(b)). If in fact the Seller is a  non-resident, 6.1(b) should be 
    stroked out and the following clause inserted.`,
    text: `The Seller discloses that the Seller is a non-resident of Canada for the purposes  of the Income Tax Act (Canada) and that a portion of the sale proceeds as  required that Act may be held back by the Buyer or Buyer’s lawyer or the Seller’s  lawyer under appropriate trust conditions until the Seller supplies the appropriate clearance certificate from the Canada Revenue Agency.`,
  },

  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Seller to pay cost of title insurance. RPR is not provided.`,
    notes: `This clause specifies that the Seller will contribute a set amount 
    toward the cost of a Title Insurance policy, which benefits both the Buyer 
    and their lender (if financing is involved). The Buyer is responsible for 
    securing the policy. Additionally, the Seller will not provide a Real 
    Property Report, which typically shows property boundaries and improvements.`,
    text: `The Seller will contribute up to $____________ towards the cost of a Title Insurance  Policy for the benefit of the Buyer and the Buyer’s lender (if financing is obtained).  The policy is to be secured by the Buyer. A Real Property Report will not be  provided.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Seller to pay cost of title insurance. Existing RPR is provided`,
    notes: `In circumstances where the Seller has an existing Real Property Report that does not  reflect the current state of the property, the RPR should be updated. If the Seller does  not want to update the RPR and the Buyer is willing, title insurance could be used in  addition to the existing RPR. In cases where an RPR is not current and title insurance  will be obtained, legal advice is recommended.`,
    text: `The Seller will provide an existing Real Property Report dated _______,  which does not reflect the current improvements on Property.  
The Seller will contribute up to $___________towards the cost of a Title Insurance  Policy for the benefit of the Buyer and Buyer’s lender (if financing is obtained).  The Policy is to be secured by the Buyer. An updated Real Property Report will  not be provided.`,
  },
  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Escalation Clause`,
    notes: `This clause outlines that the Buyer agrees to pay $1,000 more than 
    the highest competing offer, up to a specified maximum amount. The Seller 
    agrees to allow the Buyer to view the highest competing offer, but without 
    disclosing any personal information of the Buyer on that offer. This 
    provides transparency while protecting the Buyer's confidentiality.`,
    text: `The Buyer agrees to pay $1000 more than the highest competing offer to a maximum amount of $--------  (including the $1000 Mentioned)  And the Seller agrees to the Buyer viewing the highest competing offer without disclosing personal information of the Buyer on that offer.`,
  },

  {
    type: "clause",
    category: [
      `Single Family`,
      `Condo`,
      `Country Residential`,
      `Mobile/Manufactured`,
      `Agricultural`,
    ],
    isCommon: "no",
    title: `Buyer viewed by Zoom/Facetime only`,
    notes: `This clause acknowledges that the Buyer has only viewed the property 
    through Zoom or FaceTime calls on specific dates, rather than an 
    in-person visit. It also clarifies that neither the Seller, their agent, 
    nor the Buyer's agent are responsible for or guaranteeing the accuracy of 
    any information provided during these calls or any impressions the 
    Buyer may have formed in making their purchase decision.`,
    text: `Buyer and Seller acknowledge that Buyer is purchasing the property having only viewed it by Zoom calls (or facetime) on ____ (dates). The parties further agree that the Seller, their agent and the Buyer's agent are not guarantors regarding any of the information provided on these calls or impressions drawn by the Buyer in making their decision to purchase.`,
  },
];

export default clauseData;
